import React, { useState } from "react";
import { Typography } from "@mui/material";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Box } from "@mui/material";

const YCissues = () => {
  const [selectedOption, setSelectedOption] = useState("none");

  const handleChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div className="MajorConcernsContainer">
      {/* Dropdpwn for Community Engagement Issues */}
      <Box sx={{ flexGrow: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column", // Mobile: stack
              sm: "row", // Tablet/Desktop: inline
            },
            alignItems: {
              xs: "flex-start",
              sm: "center",
            },
            gap: 2, // adds spacing between text and dropdown
          }}
        >
          <Typography className="issues-area-helper">Key Issues In</Typography>

          <FormControl
            sx={{
              width: {
                xs: "100%",
                sm: 300,
              },
            }}
            className="AreaFormControl"
          >
            <Select
              labelId="Area-label"
              id="Area"
              value={selectedOption}
              onChange={handleChange}
              displayEmpty
              className="IssueAreaSelect"
            >
              <MenuItem value="none">
                <em>-- Select an area --</em>
              </MenuItem>
              <MenuItem value="Evinston">Evinston</MenuItem>
              <MenuItem value="Gordon">Gordon</MenuItem>
              <MenuItem value="Hawthorne">Hawthorne</MenuItem>
              <MenuItem value="IslandGrove">Island Grove</MenuItem>
              <MenuItem value="Melrose">Melrose</MenuItem>
              <MenuItem value="Micanopy">Micanopy</MenuItem>
              <MenuItem value="Monteocha">Monteocha</MenuItem>
              <MenuItem value="OrangeHeights">Orange Heights</MenuItem>
              <MenuItem value="Rochelle">Rochelle</MenuItem>
              <MenuItem value="Waldo">Waldo</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>
      {/* Concerns for selected are to be displayed */}
      <div className="MajorConcernsData">
        {selectedOption === "none" && (
          <Typography variant="body2">
            <p className="ZeroBottomMargin">
              Please select an area from the above dropdown to view youth
              concers related to it.
            </p>
          </Typography>
        )}{" "}
        {selectedOption === "OrangeHeights" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Evinston" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Gordon" && (
          <Typography
            variant="body1"
            style={{
              paddingLeft: "1%",
            }}
          >
            There is currently no data available for this area. If you have a
            comment, please fill out our{" "}
            <a target="_blank" href="https://wkf.ms/4jlqDeG" rel="noreferrer">
              form
            </a>
            .
          </Typography>
        )}
        {selectedOption === "Hawthorne" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Need a multi-purpose building for school programs and community
                activities
              </li>
              <li>Youth feel left out and need a dedicated community center</li>
              <li>
                Concerns about limited local opportunities for youth and their
                future
              </li>
              <li>Improve and maintain school facilities</li>
              <li>Need more affordable child care options in the area</li>
              <li>Need accessible daycare facilities</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "IslandGrove" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Residents would like to bring back the mobile library</li>
              <li>
                Marjorie Kinnan Rawlings Park needs maintenance and a space for
                kids
              </li>
              <li>
                Residents want more activities for youth at Kate Barnes Park,
                like basketball
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Melrose" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>There are few safe spaces for children to play or gather</li>
              <li>
                Residents want a public pool and a water safety program to
                prevent child drownings
              </li>
              <li>
                Community members expressed a strong desire for post-high school
                opportunities, like a Santa Fe College satellite campus focused
                on trades such as welding and gunsmithing
              </li>
              <li>
                Many rural students are not attending college, so trade programs
                are seen as a key path to economic stability
              </li>
              <li>
                The Alachua County startup trade program with Santa Fe should be
                promoted more in Melrose schools
              </li>
              <li>
                There is no current transportation to Santa Fe, which limits
                participation
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Micanopy" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Micanopy needs a high school to address the lack of accessible
                education
              </li>
              <li>
                Improve leadership and management at the Micanopy cooperative
                school
              </li>
              <li>
                Invest in community initiatives with a focus on young people
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Monteocha" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>Childcare services are needed</li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Rochelle" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>More job opportunities for young people are needed </li>
              <li>
                Alachua County’s free dual enrollment program with Santa Fe need
                to be taken advantage of at Hawthorne high school
              </li>
              <li>Desire to build a Santa Fe satellite campus in Hawthorne</li>
              <li>Desire for young people to pick up trades </li>
              <li>
                PEAK literacy works in Hawthorne elementary and would like
                volunteers and to expand to more schools
              </li>
            </ul>
          </Typography>
        )}
        {selectedOption === "Waldo" && (
          <Typography variant="body2">
            <ul className="ZeroBottomMargin">
              <li>
                Idea to build a sports complex to support the new Constellation
                Charter School
              </li>
              <li>
                Increase recruitment of kids into Waldo to help promote the
                school
              </li>
              <li>
                Address the lack of childcare services, especially after the
                loss of VPK
              </li>
              <li>Address the lack of jobs and activities for local youth </li>
            </ul>
          </Typography>
        )}
      </div>
    </div>
  );
};

export default YCissues;
